import gql from 'graphql-tag';

export const UPDATE_LOOK_TAG_FILTER = gql`
  mutation updateLookTagFilter($filter: TagFilterInput!, $orderBy: [String]) {
    updateLookTagFilter(filter: $filter, orderBy: $orderBy) @client
  }
`;
